import { $journalApi } from "@/entities/journal/fetch/fetch-client";

export const useGetItemsVersion = (
  sectionFourListId?: string,
  itemNoVersionId?: string,
) =>
  $journalApi.useQuery(
    "get",
    "/api/v1/journals/section-four/{sectionFourListId}/items/{itemNoVersionId}/versions",
    {
      params: {
        path: {
          sectionFourListId: sectionFourListId!,
          itemNoVersionId: itemNoVersionId!,
        },
      },
      enabled: !!sectionFourListId && !!itemNoVersionId,
    },
    {
      staleTime: 0,
      refetchOnMount: "always",
    },
  ); 
